<template>
  <v-app class="main-layout">
    <!-- drawer -->
    <v-navigation-drawer
      app
      clipped
      fixed
      light
      :mini-variant="!sidebarExpanded"
      mini-variant-width="81"
      width="325"
      mobile-breakpoint="720"
      :v-model="drawerState"
      color="#F8F8F8"
      class="roma-drawer sidebar d-flex flex-column sombra-1"
    > 

      <div class="mt-8 px-2 d-flex align-items-center mb-7" v-if="user.institutionContext">
        <v-img
            :src="
                `https://plataforma.romacl.com/LogoInstitucion?id=${user.institutionContext.identificationCode}`
            "
            :lazy-src="
                `https://plataforma.romacl.com/LogoInstitucion?id=${user.institutionContext.identificationCode}`
            "
            width="64px"
        ></v-img>
        <div class="d-flex flex-column ml-2" v-if="sidebarExpanded">
          <span class="font-inter titulo-6 font-weight-600">
            {{ user.institutionContext.identificationCode }}
          </span>

          <span class="font-inter titulo-5 font-weight-600">
            {{ textCapitalize(user.institutionContext.name) }}
          </span>
          <small class="font-inter parrafo-2 font-weight-500 color-neutro-1">
            Año {{ user.institutionContext.yearSelected }}
          </small>
          </div>
      </div>
      <v-list nav class="px-0 first-sidebar-list">
        <!-- items -->
        <v-list-item
          link
          v-for="(link, i) in options"
          :key="i"
          :to="{ name: link.to }"
          exact-active-class="roma-active"
          overlay-color="#F1E5FF"
          :class="{
            'd-none': !showMenuItem(link.roles)
          }"
        >
          <v-list-item-action class="drawer-item">
            <img :src="link.icon" alt class="default" />
            <img :src="link.iconActive" class="active" alt />
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="font-inter parrafo-1 color-neutro-1">{{
              link.title
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      
      <v-col class="d-flex flex-column justify-content-end px-0"
      :class="{
        'align-items-center': !sidebarExpanded
      }">
        <div class="d-flex justify-content-center flex-column align-items-center" v-if="isAulaVirtual()">
          <h3 class="mt-3 titulo-2 font-weight-600" v-if="sidebarExpanded">Avance General</h3>
          <v-progress-circular
            :rotate="-90"
            :size="100"
            :width="7"
            :value="generalAdvance.progress"
            color="#743085"
            class=""
            v-if="sidebarExpanded"
          >
            <v-avatar class="roma-card__avatar-card">
              <span class="color-purpura-base titulo-2 font-weight-600">{{ generalAdvance.progress }}%</span>
            </v-avatar>
          </v-progress-circular>
        </div>
        <v-list nav class="px-0">
          <!-- items -->
          <v-list-item
            @click="toggleSidebar()"
          >
            <v-list-item-action class="drawer-item">
              <v-icon v-if="sidebarExpanded">mdi-arrow-left</v-icon>
              <v-icon v-if="!sidebarExpanded">mdi-arrow-right</v-icon>
            </v-list-item-action>
            <v-list-item-content v-if="sidebarExpanded">
              <v-list-item-title class="font-inter parrafo-1 color-neutro-1 font-weight-500">
                Minimizar
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <div  class="mt-3"
        :class="{
          'ml-5': sidebarExpanded
        }">
          <img src="@/assets/images/logo-roma.svg" 
          class="w-100" 
          :width="sidebarExpanded? '111px':'60px'" />
        </div>
      </v-col>
      
    </v-navigation-drawer>

    <!-- temporary drawer -->
    <v-navigation-drawer 
      v-model="left" color="#F8F8F8"
      class="roma-drawer sidebar d-flex flex-column sombra-1" 
      fixed 
      temporary>
      <div class="mt-8 px-2 d-flex justify-content-center align-items-center mb-7" v-if="user.institutionContext">
        <v-img
            :src="
                `https://plataforma.romacl.com/LogoInstitucion?id=${user.institutionContext.identificationCode}`
            "
            :lazy-src="
                `https://plataforma.romacl.com/LogoInstitucion?id=${user.institutionContext.identificationCode}`
            "
            max-width="64px"
            width="64px"
        ></v-img>
        <div class="d-flex flex-column ml-2">
          <span class="font-inter titulo-6 font-weight-600">
            {{ user.institutionContext.identificationCode }}
          </span>

          <span class="font-inter titulo-5 font-weight-600">
            {{ textCapitalize(user.institutionContext.name) }}
          </span>
          <small class="font-inter parrafo-2 font-weight-500 color-neutro-1">
            Año {{ user.institutionContext.yearSelected }}
          </small>
        </div>
      </div>
      <v-list nav class="px-0 first-sidebar-list">
        <!-- items -->
        <v-list-item
          link
          v-for="(link, i) in options"
          :key="i"
          :to="{ name: link.to }"
          exact-active-class="roma-active"
          overlay-color="#F1E5FF"
          :class="{
            'd-none': !showMenuItem(link.roles)
          }"
        >
          <v-list-item-action class="drawer-item">
            <img :src="link.icon" alt class="default" />
            <img :src="link.iconActive" class="active" alt />
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title class="font-inter parrafo-1 color-neutro-1">{{
              link.title
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      
      <v-col class="text-center d-flex flex-column justify-content-end align-items-center">
        <h3 class="mt-3 titulo-2 font-weight-600" v-if="isAulaVirtual() || isEvaluacionesAulaVirtual()">Avance General</h3>
        <v-progress-circular
          :rotate="-90"
          :size="100"
          :width="7"
          :value="generalAdvance.progress"
          color="#743085"
          v-if="isAulaVirtual() || isEvaluacionesAulaVirtual()"
        >
          <v-avatar class="roma-card__avatar-card">
            <span class="color-purpura-base titulo-2 font-weight-600">{{ generalAdvance.progress }}%</span>
          </v-avatar>
        </v-progress-circular>
        <div class="mt-3">
          <img src="@/assets/images/logo-roma.svg" 
          class="w-100" 
          width="90px" />
        </div>
      </v-col>
    </v-navigation-drawer>
    
    <!-- main -->
    <RomaHeader :dpDrawer="ToggleDrawer" :dpTemporary="toggleTemporary" />
    <v-main class="float-left">
      <v-container class="bg-white page-wrapper" fluid style="padding: 0">
        <router-view v-if="isAulaVirtual() || isEvaluacionesAulaVirtual()" :sidebarExpanded="sidebarExpanded"></router-view>
        <template v-if="!user.roles.length">
          <div style="padding:20px">
            <div class="px-3 m-5">
              <v-row>
                <v-col cols="12" class="d-flex align-items-center info-box parrafo-2" style="border-color: #DC2626; background-color:#dc26260d">
                <v-icon color="#DC2626" class="mr-2">mdi-information-outline</v-icon>  
                Sin accesos a evaluaciones desde aulavirtual.
              </v-col>
              </v-row>
            </div>
          </div>          
        </template>
      </v-container>
    </v-main>
  </v-app>
</template>

<script >
import { mapGetters, mapActions } from "vuex";
import RomaHeader from "./RomaHeader.vue";
export default {
  data() {
    return {
      drawerState: null,
      left: false,
      sidebarExpanded: false,
      options: [
        {
          title: "¿Qué Estudio Hoy?",
          icon: require("@/assets/icons/my_class_icon.svg"),
          iconActive: require("@/assets/icons/online-course.svg"),
          to: "Lesson",
          roles: ['AulaVirtual']
        },
        {
          title: "Mis Tareas",
          icon: require("@/assets/icons/tasks-reviews-icon.svg"),
          iconActive: require("@/assets/icons/tasks-reviews-icon-v2.svg"),
          to: "Tareas",
          roles: ['AulaVirtual']
        },
        {
          title: "Mis Evaluaciones",
          icon: require("@/assets/icons/my_class_icon.svg"),
          iconActive: require("@/assets/icons/online-course.svg"),
          to: "Evaluations",
          roles: ['EvaluacionesAulaVirtual']
        }
      ],
      sidebarPanelOptions: [
        {
          title: "Minimizar",
          icon: 'mdi-arrow-left',
          panelExpanded: true
        },
        {
          title: "Maximizar",
          icon: 'mdi-arrow-right',
          panelExpanded: false
        }
      ]
    };
  },
  components: {
    RomaHeader
  },
  computed: {
    ...mapGetters({
      generalAdvance: "getGeneralAdvance",
      user: "getUserData"
    })
  },
  methods: {
    textCapitalize(value){
      let aux = value.trim().split(' ');
      aux = aux.filter( element => element != '');
      aux = aux.map( (word, index) => {
        word = word.trim();
        return word[0].toUpperCase() + word.slice(1).toLowerCase();
      })
      return aux.join(' ');
    },
    isAulaVirtual(){
      if(this.user && this.user.roles){
        const result = this.user.roles.includes('AulaVirtual');
        return result;
      }
    },
    isEvaluacionesAulaVirtual(){
      if(this.user && this.user.roles){
        const result = this.user.roles.includes('EvaluacionesAulaVirtual');
        if(result && this.$router.currentRoute.path != '/evaluaciones'){
          this.$router.push({ path: '/evaluaciones' })
        }
        return result;
      }
    },
    showMenuItem(roles){
      let pass = false;
      if(this.user && this.user.roles){
        roles.forEach(
          (item) => {
            pass = pass || this.user.roles.includes(item);
          }
        )
      }
      return pass;
    },
    toggleSidebar(){
      this.sidebarExpanded = !this.sidebarExpanded;
    },
    ToggleDrawer() {
      this.drawerState = !this.drawerState;
    },
    toggleTemporary() {
      this.left = !this.left;
    },
    progress(value) {
      if (value <= 25) {
        this.color = "secondary";
      } else if (value >= 26 && value <= 49) {
        this.color = "purple";
      } else if (value >= 50 && value <= 75) {
        this.color = "accent";
      } else if (value >= 76 && value <= 90) {
        this.color = "blueMedium";
      } else {
        this.color = "green";
      }
      return this.color;
    }
  }
};
</script>
<style lang="scss">
@import '../../assets/styles/generals.scss';

.roma-active{
  border-left: solid purple 4px;
  .v-list-item__title {
    color: $purple_base !important;
  }
}

.v-navigation-drawer__content{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.sidebar{
  top: 0px !important;
  max-height: 100% !important;
  z-index: 9999 !important;
  .first-sidebar-list{
    width: 100%;
  }
}
.open-drawer {
  margin-left: 0 !important;
  padding-left: 0 !important;
}

.close-drawer {
  padding-left: 250px !important;
}

.user {
  padding: 0 1rem;
  display: grid;
  grid-template-columns: 1fr max-content;
  grid-gap: 0 1rem;
}
.page-wrapper {
  height: 100%;
}
.bg-white {
  background: white !important;
}
</style>
